import 'css-chunk:../authentication/frontend/pages/email-sent-page/index.module.scss';export default {
  "icon": "_icon_1ifes_1",
  "body": "_body_1ifes_6"
};